import React from 'react';
import { LanguageProvider, LocalizedText } from './i18n/Language';
import './App.css';
import Header from './components/Header';
import HomePage from './components/HomePage';
import BookAppointment from './components/BookAppointment';
import Location from './components/Location';
import Footer from './components/Footer';
import Services from './components/Services';
import QuickContact from './components/QuickContact';

function App({ path = '/' }) {
  const servicesPage = path.replace(/\/$/, '') === '/services';
  return (
    <LanguageProvider><div className="App">
      <a href="#main-content" className="sr-only focus:not-sr-only"><LocalizedText>Skip to content</LocalizedText></a>
      <Header />
      <main id="main-content">
        {servicesPage ? <Services /> : <HomePage />}
        <BookAppointment />
        <Location />
      </main>
      <Footer />
      <QuickContact />
    </div></LanguageProvider>
  );
}
export default App;
